<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/scale-with-business.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				Compliance That <br class="d-none d-sm-block" />
				Scales With Your <br class="d-none d-sm-block" />
				Business
			</h1>
			<p class="shift-compliance-para mt-4">
				Enable and configure our core modules to meet
				<br class="d-none d-sm-block" />
				the full scope of your organization's compliance
				<br class="d-none d-sm-block" />
				needs today and in the future. Our users have
				<br class="d-none d-sm-block" />
				access to all modules—when needed—at no
				<br class="d-none d-sm-block" />
				additional cost.
			</p>
		</div>
	</div>
</div>
